import styled from '@emotion/styled'
import { Dialog } from '@mui/material'

const PaddedDialog = styled(Dialog)`
	display: flex;
	justify-content: center;
	align-items: center;

	.MuiPaper-root {
		top: initial !important;
		left: initial !important;
	}

	.MuiDialog-paper {
		padding: 30px;
	}

	'.MuiBackdrop-root': {
		backgroundColor: 'transparent',
	},
`
export { PaddedDialog }
